// export const server = "https://eshop-tutorial.vercel.app/api/v2";
export const server = "https://eshop-backend-h98h.onrender.com/api/v2";
export const backend_url = "http://localhost:8000/";


